import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { withData } from '../utility/DataContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TimeAgo from 'react-timeago';
import chineseStrings from 'react-timeago/lib/language-strings/zh-TW';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import MemeDetail from './MemeDetail';
import TextField from '@material-ui/core/TextField';
 

const formatter = buildFormatter(chineseStrings)

const getSorting = (order, orderBy) => {
  if (orderBy === 'name'){
    return order === 'desc' ? (a, b) => a.name.localeCompare(b.name) : (a, b) => b.name.localeCompare(a.name);
  }else{
    return order === 'desc' ? (a, b) => b[orderBy] - a[orderBy] : (a, b) => a[orderBy] - b[orderBy];
  }
}

const columnData = [
  { id: 'name', numeric: false, label: '貼圖名稱' },
  { id: 'count', numeric: true, label: '使用次數' },
  { id: 'date', numeric: true, label: '時間' },
];


class DataTablesHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, classes } = this.props;

    return (
      <TableHead classes={{root: classes.head}}>
        <TableRow style={{height: 40}}>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                sortDirection={orderBy === column.id ? order : false}
                classes={{root: classes.cell}}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                  classes={{root: classes.label, active: classes.active}}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

const CustomHead = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.grey[50],
  },
  cell: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    fontSize: 13,
    color: theme.palette.primary.main
  },
  active: {
    color: theme.palette.primary.light,
  },
  label: {
    '&:hover': {
      color: theme.palette.primary.main
    }
  }
}))(DataTablesHead);


const styles = theme => ({
  table: {
    
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  loading: {
    width: '100%',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4
  },
  row: {
    cursor: 'pointer',
  },
  cell: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3
  },
  searchDiv :{
    backgroundColor: theme.palette.grey[100],
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    display: 'flex',
    justifyContent: 'center'
  },
  textField: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});


class DataTables extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: 'desc',
      orderBy: 'name',
      page: 0,
      rowsPerPage: 10,
      loaded: false,
      data: [],
      template: null,
      searchText: '',
    };
  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.mode !== this.props.mode && this.props.mode !== 'total'){
      this.updateData();
    }
  }

  updateData = () => {
    this.props.data.firestore.collection('templates').get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        var data = doc.data()
        data.id = doc.id;
        data.name = doc.id;
        data.date = data.date.toMillis();
        this.setState(prevState => {
          return {
            data: [...prevState.data, data],
            loaded: true,
          };
        });
      });
    });
  }

  changeSearchText = event => {
    const searchText = event.target.value;
    this.setState({searchText});
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    const page = 0;

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy, page });
    this.forceUpdate()
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleClick = (event, d) => {
    this.setState({template: null}, ()=>this.setState({template: d}));
  };

  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <div>
        {!this.state.loaded && 
          <Grid container justify="center" alignItems="center" className={classes.loading}>
            <CircularProgress color="primary" size={150} thickness={1.5} />
          </Grid>
        }
        {this.state.loaded && 
          <React.Fragment>
            <div className={classes.searchDiv}>
              <TextField
                id="search"
                type="search"
                placeholder='搜尋'
                className={classes.textField}
                margin="none"
                onChange={this.changeSearchText}
              />
            </div>
            <div className={classes.tableWrapper}>
              <Table className={classes.table}>
                <CustomHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={this.handleRequestSort}
                />
                <TableBody>
                  {data
                    .filter(d => {
                      return d.name.toLowerCase().includes(this.state.searchText.toLowerCase());
                    })
                    .sort(getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(n => {
                      return (
                        <TableRow
                          hover
                          onClick={event => this.handleClick(event, n)}
                          tabIndex={-1}
                          key={n.id}
                          className={classes.row}
                        >
                          <TableCell classes={{root: classes.cell}} style={{fontSize: 16}}>
                            {n.id}
                          </TableCell>
                          <TableCell numeric classes={{root: classes.cell}}>
                            {n.count}
                          </TableCell>
                          <TableCell numeric classes={{root: classes.cell}}>
                            <TimeAgo date={n.date} live={false} formatter={formatter} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 48 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage='每頁顯示數量'
              page={page}
              backIconButtonProps={{
                'aria-label': '上一頁',
              }}
              nextIconButtonProps={{
                'aria-label': '下一頁',
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </React.Fragment>
        }
        <MemeDetail template={this.state.template} />
      </div>
    );
  }
}

export default withData(withStyles(styles)(DataTables));


// WEBPACK FOOTER //
// ./src/components/DataTables.js